import { render, staticRenderFns } from "./LayoutOnly.vue?vue&type=template&id=1c16c31a&"
import script from "./LayoutOnly.vue?vue&type=script&lang=js&"
export * from "./LayoutOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports